import { Button, useStyles } from '@archipro-design/aria';
import * as S from './DeleteDesignBoardDialog.style';

interface DeleteDesignBoardDialogProps {
    onCancel: () => void;
    onDelete: () => void;
    modalContent?: string;
    modalHeader?: string;
    loading?: boolean;
}

export const DeleteDesignBoardDialog = ({
    onCancel,
    onDelete,
    loading = false,
    modalContent = `
    Are you sure you would like to delete this board? All board
    content will be lost.`,
    modalHeader = 'Delete Board',
}: DeleteDesignBoardDialogProps) => {
    const { css } = useStyles();

    return (
        <div className={css(S.DeleteBoardModalContainer)}>
            <div className={css(S.DeleteBoardHeader)}>{modalHeader}</div>
            <div className={css(S.DeleteBoardMessage)}>{modalContent}</div>
            <div className={css(S.DeleteBoardModalButtonContainer)}>
                <Button
                    onClick={() => {
                        onDelete();
                    }}
                    size={16}
                    disabled={loading}
                    loading={loading}
                >
                    DELETE
                </Button>
                <Button
                    onClick={() => onCancel()}
                    key="deleteDesignBoardModalButton"
                    color="dark"
                    variant="outlined"
                    size={16}
                    disabled={loading}
                >
                    CANCEL
                </Button>
            </div>
        </div>
    );
};
